import { z } from 'zod';

export const GameConfigSchema = z.object({
  options: z.number().int().min(2),
  feedbackMs: z.number().int().min(0),
  base: z.record(z.string(), z.number()),
  streakBonus: z.number(),
});
export type GameConfig = z.infer<typeof GameConfigSchema>;

export const gameConfig: GameConfig = GameConfigSchema.parse({
  options: 4,
  feedbackMs: 750,
  base: { 1: 10, 2: 20, 3: 35 },
  streakBonus: 2,
});
